// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import { Link } from "react-router-dom";
import ContactBand from "../../ContactBand";

export default function CasePremience() {
  return (
    <main>
      <section className="page-hero ground cd-hero" data-en="WORKS">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">トップ</Link>
            <Link to="/cases">実績・事例</Link>
            <span>プレミエンス</span>
          </nav>
          <div className="case-tags cd-tags">
            <span>旅行・観光</span>
            <span>ブランディング・Web制作</span>
          </div>
          <h1 className="cd-title">
            JTBのラグジュアリー体験ブランド「プレミエンス」のロゴ制作とサイトリニューアル
          </h1>
          <p className="cd-client">株式会社JTB</p>
          <div className="cd-img">
            <img src="/assets/images/case-premience.jpg" alt="" />
          </div>
          <div className="cd-summary">
            <div>
              <span>課題</span>
              <p>
                特別な体験を届けるブランドとして、ロゴとサイトの世界観を整えたかった。
              </p>
            </div>
            <div>
              <span>解決策</span>
              <p>ロゴの制作からサイトのデザイン・実装までを一貫して担当。</p>
            </div>
            <div>
              <span>成果</span>
              <p>ブランドの世界観をそろえた、新しいロゴとサイトに刷新。</p>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="cd-body container">
          <section className="cd-sec">
            <h2>プロジェクト概要</h2>
            <p>
              JTBロイヤルロード銀座が手がける、スポーツ観戦のVIP席やホスピタリティプログラムなど、ご自身では手配が難しい特別な体験を届けるブランド「プレミエンス」の、ロゴ制作とWebサイトのリニューアルを行いました。
            </p>
          </section>
          <section className="cd-sec">
            <h2>お客様の課題</h2>
            <ul className="cd-list">
              <li>
                ブランドとしての世界観を、ひと目で伝えられるロゴが必要だった
              </li>
              <li>
                ラグジュアリーな体験にふさわしいサイトのデザインに刷新したかった
              </li>
              <li>
                既存のサイトの環境に合わせて、トップから下層ページまでを整えたかった
              </li>
            </ul>
          </section>
          <section className="cd-sec">
            <h2>LEAPSの対応</h2>
            <div className="cd-point">
              <span className="cd-num">01</span>
              <div>
                <p className="cd-cat">ロゴ制作</p>
                <h3 className="cd-ptitle">ブランドを象徴するロゴマーク</h3>
                <p>
                  アートディレクションからロゴの案出し、仕上げ、簡易的なロゴマニュアルの作成までを行いました。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">02</span>
              <div>
                <p className="cd-cat">サイトデザイン</p>
                <h3 className="cd-ptitle">トップから下層ページまで</h3>
                <p>
                  ブランドの世界観に合わせて、トップページと下層ページのデザイン、掲載する写真の選定・編集を行いました。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">03</span>
              <div>
                <p className="cd-cat">実装</p>
                <h3 className="cd-ptitle">既存環境に合わせた構築</h3>
                <p>
                  JTBの既存のサイト環境に合わせて、デザインしたページを実装しました。
                </p>
              </div>
            </div>
          </section>
          <section className="cd-sec">
            <h2>成果</h2>
            <p>
              ロゴとサイトの世界観をそろえ、特別な体験を届けるブランドとしての印象を高めました。
            </p>
          </section>
        </div>
      </section>
      <section className="section ground">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            ほかの事例<strong>Other Works</strong>
          </h2>
          <div className="case-grid">
            <Link className="case-card" to="/cases/anybound">
              <div className="case-img">
                <img
                  src="https://stg.leaps-inc.com/cms-admin/wp-content/uploads/2026/03/FV-1024x610.png"
                  alt=""
                />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                希少な旅行体験をブロックチェーンで流通させる共創プロジェクト「anyBOUND」
              </h3>
              <div className="case-tags">
                <span>エンタープライズ</span>
                <span>ブロックチェーン事業開発</span>
                <span>共創プロジェクト</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/kanda-curry">
              <div className="case-img is-cover">
                <span className="cover-en">NFT STAMP RALLY</span>
                <span className="cover-ja">スタンプラリー × NFT</span>
              </div>
              <p className="case-meta">広告代理店</p>
              <h3>
                スタンプラリーの思い出をNFTで残す「神田カレーグランプリ2025」
              </h3>
              <div className="case-tags">
                <span>イベント・観光</span>
                <span>ブロックチェーン事業開発</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/hikky">
              <div className="case-img is-cover">
                <span className="cover-en">METAVERSE NFT</span>
                <span className="cover-ja">メタバース × NFT</span>
              </div>
              <p className="case-meta">メタバース事業会社</p>
              <h3>メタバース霊園の土地と遺品を、NFTで受け継げる仕組みに</h3>
              <div className="case-tags">
                <span>メタバース・エンタメ</span>
                <span>ブロックチェーン事業開発</span>
              </div>
            </Link>
          </div>
          <div className="more">
            <Link to="/cases">実績一覧を見る →</Link>
          </div>
        </div>
      </section>
      <ContactBand ground={false} />
    </main>
  );
}
